module.exports = __webpack_public_path__ + "img/sweetkill.12aa2450.jpg";